<template lang="pug">
    v-dialog(v-model="_value" fullscreen)
        v-toolbar(
            :color="colors.primary"
            dark
        )
            v-btn(icon='' dark='' @click='_value = false')
                v-icon close
            span.title Detalle Venta
        v-card
            v-layout
                v-flex
                    detail-header
                    template(v-for="(item, idx) in items" )
                        item-strip.white(
                            :value="items[idx]"
                            @input="itemChangeHandler(idx, $event)"
                            
                            @action="$event(items, idx)"
                            :key="item.id"
                            
                            enableEditQuantity=false
                        )
</template>

<script>
// -- Component Imports --
import ItemStrip from '@/components/ItemStrip/ItemStrip'
import CartHeaders from '@/components/CashDesk/Detail/CartHeaders'
// -- JS Data files import --
// -- JS Libraries Import --
// -- Mixins imports --
// -- Vuex Imports --
import { mapState } from 'vuex'
// -- Other Imports --
export default {
    name: 'sale-detail-modal',
    props: {
        // ------------------------- UI State ---------------------------------
        /**
         * @description
         */
        value: {
            type: Boolean,
            default: () => false,
        },
        // ------------------------- Component Data ---------------------------
    },
    data: function() {
        return {
            // ------------------------ UI State ------------------------------
            // ------------------------ Data storing --------------------------
        }
    },
    computed: {
        // -------------------- Editable props binding-------------------------
        /**
         * @description
         */
        _value: {
            get: function() {
                return this.value
            },
            set: function(val) {
                this.$emit('input', val)
            },
        },
        // -------------------- Alias settings --------------------------------
        // -------------------- Dynamic UI State ------------------------------
        // -------------------- Displayed data --------------------------------
        // -------------------- Methods data ----------------------------------
        // -------------------- Vuex mappings ---------------------------------
        ...mapState('CashDeskModule', {
            items: 'saleDetail',
        }),
    },
    methods: {
        // -------------------- UI Modification -------------------------------
        // -------------------- Data fetching ---------------------------------
        // -------------------- Data handling and transformations -------------
        // -------------------- Validations and Error handling ----------------
        // -------------------- Other functions -------------------------------
        // -------------------- Vuex mappings ---------------------------------
    },
    // watch: {},
    components: {
        'item-strip' : ItemStrip,
        'detail-header':CartHeaders
    },
    // mixins: [],
    // filters: {},
    // ------------------------ Lifecycle Methods -----------------------------
    // ------------------------ End Lifecycle Methods -------------------------
}
</script>

<style lang="scss">
</style>